import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { featureKey } from './reducers/feature-key';
import { genesysCloudEmailConversationsReducer } from './reducers/email-conversation.reducers';
import { GenesysCloudEmailConversationsInitializeModuleEffects } from './effects/initialize-module.effects';
import { GenesysCloudEmailConversationEffects } from './effects/email-conversation.effects';
import { GenesysCloudEmailMessageEffects } from './effects/email-message.effects';
import { GenesysCloudEmailDraftsEffects } from './effects/email-drafts.effects';

@NgModule({
  imports: [
    StoreModule.forFeature(featureKey, genesysCloudEmailConversationsReducer),
    EffectsModule.forFeature([
      GenesysCloudEmailConversationsInitializeModuleEffects,
      GenesysCloudEmailConversationEffects,
      GenesysCloudEmailMessageEffects,
      GenesysCloudEmailDraftsEffects
    ])
  ]
})
export class GenesysCloudEmailConversationsModule {
}
